import React from "react";
import {Box, Typography} from "@mui/material";
import {SocialIcon} from "react-social-icons";

const SocialHandles = ({icon, handle}) => {
  function isMobile() {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const minSize = 450;
    return screenWidth <= minSize;
  }
  return (
    <Box display={isMobile()?"grid":"flex"} justifyContent={isMobile()?"left":"center"} alignItems="center" gap={isMobile()?0:1}>
      <SocialIcon
        network={icon?.toLowerCase()}
        style={{
          fontSize: isMobile()?"8px":"10px",
          backgroundColor: "white",
          width:isMobile()?"10px":"20px",
          height: isMobile()?"10px":"20px",
        }}
      />
      <Typography sx={{color: "#928F95", fontWeight: "600", fontSize:isMobile()?"10px":"12px"}}>{handle}</Typography>
    </Box>
  );
};

export default SocialHandles;
